import { ICalculatorMcfValues } from '../../types/features/calculator';

export const replaceUndefinedWithNull = (
  obj: ICalculatorMcfValues,
): Record<string, number | string | boolean | null | undefined> =>
  Object.keys(obj).reduce(
    (acc, key: keyof ICalculatorMcfValues) => {
      acc[key] = obj[key] === undefined ? null : obj[key];

      return acc;
    },
    {} as Record<string, number | string | boolean | null | undefined>,
  );
